import { render, staticRenderFns } from "./ProductInfoModal.vue?vue&type=template&id=59a1851d&scoped=true"
import script from "./ProductInfoModal.vue?vue&type=script&lang=js"
export * from "./ProductInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoModal.vue?vue&type=style&index=0&id=59a1851d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a1851d",
  null
  
)

export default component.exports